// extracted by mini-css-extract-plugin
export default {"productGallery":"pG-z","inQuickShop":"qG-z"};